// extracted by mini-css-extract-plugin
export default {"variants":"MatchWordsImages_variants__tg62P","images":"MatchWordsImages_images__FDMtR","answer":"MatchWordsImages_answer__wokFr"};